import { useState, useEffect, useCallback } from "react";

const ENTER_CODE = "Enter";

export const useSearchInput = () => {
  const [inputValue, setInputValue] = useState("");
  const [valuePresent, setValuePresent] = useState(false);

  const inputHandler = useCallback((value: string) => {
    setInputValue(value);
  }, []);

  const enterHandler = useCallback(
    (e, btnHandler) => {
      if (e.key === ENTER_CODE && !!inputValue.length) {
        btnHandler();
      }
    },
    [inputValue]
  );

  useEffect(() => {
    const hasValue = inputValue.length > 0;

    setValuePresent((prevVal) => {
      if (prevVal && hasValue) return prevVal;
      return !prevVal && hasValue;
    });
  }, [inputValue]);

  return {
    inputValue,
    inputHandler,
    valuePresent,
    enterHandler,
  };
};
